const toc =
  "TERMS AND CONDTITIONS\n\n" +
  "By using this tool, you agree that any and all responsobility " +
  "for all resulting abuses of copyright, trademarks, patents, and" +
  " any other types of intelectual property is entirely yours.";

export default toc;
